// A 7-segment LED display (like a digital alarm clock). Every segment is drawn
// dim ("ghost" — the off state), with the active ones lit and glowing, exactly
// like a real LED where you can faintly see the unlit segments. Pure CSS
// segments, no font asset (§4.2). Size is driven by the `--seg-w` CSS var on the
// container (.bz-seg7); colours come from --seg-on/off/glow so callers can theme
// per state (e.g. red when done). Purely presentational.

import { memo } from 'react';

// Which segments (a top, b top-right, c bottom-right, d bottom, e bottom-left,
// f top-left, g middle) are lit for each digit.
const DIGIT: Record<string, string> = {
  '0': 'abcdef',
  '1': 'bc',
  '2': 'abdeg',
  '3': 'abcdg',
  '4': 'bcfg',
  '5': 'acdfg',
  '6': 'acdefg',
  '7': 'abc',
  '8': 'abcdefg',
  '9': 'abcdfg',
};
const SEGS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'] as const;

export const SevenSeg = memo(function SevenSeg({ value }: { value: string }) {
  return (
    <span className="bz-seg7" role="timer" aria-label={value}>
      {value.split('').map((ch, i) =>
        ch === ':' ? (
          <span key={i} className="bz-seg7-colon" aria-hidden="true">
            <i />
            <i />
          </span>
        ) : (
          <span key={i} className="bz-seg7-digit" aria-hidden="true">
            {SEGS.map((s) => (
              <i key={s} className={`bz-seg7-${s}${(DIGIT[ch] ?? '').includes(s) ? ' bz-on' : ''}`} />
            ))}
          </span>
        ),
      )}
    </span>
  );
});
